/* Instagram has no web share composer: copy the public link, never imply a post. */
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-instagram-share][open]').forEach(function (panel) {
      if (!panel.contains(event.target)) panel.open = false;
    });
    var summary = event.target.closest('[data-instagram-share] > summary');
    if (!summary) return;
    event.preventDefault();
    var panel = summary.parentElement;
    panel.open = !panel.open;
    if (!panel.open) return;
    var status = panel.querySelector('[data-share-status]');
    var input = panel.querySelector('[data-share-input]');
    status.textContent = panel.dataset.manual;
    input.hidden = false;
    function revealPanel() {
      if (panel.open) panel.querySelector('.social-sharing__panel').scrollIntoView({ block: 'nearest' });
    }
    function manualCopy() {
      if (!panel.open) return;
      input.hidden = false;
      revealPanel();
      input.focus({ preventScroll: true });
      input.select();
    }
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        manualCopy();
        return;
      }
      navigator.clipboard.writeText(panel.dataset.shareUrl).then(function () {
        status.textContent = panel.dataset.copied;
        input.hidden = true;
        revealPanel();
      }).catch(manualCopy);
    } catch (error) {
      manualCopy();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var panel = event.target.closest('[data-instagram-share][open]');
    if (!panel) return;
    event.preventDefault();
    event.stopPropagation();
    panel.open = false;
    panel.querySelector('summary').focus();
  });
})();
